/** @file View depth of a world point in units relative to the camera target; grows away from the camera. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import { vec3Sub } from '@zilo/pose3d-math/vec3/vec3Sub';
import { projectOffset } from '@zilo/pose3d-render-core/camera/projectOffset';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';

/** `projectOffset(p - target)[2]`: nearer is smaller. */
export function viewDepth(p: Vec3, view: View): number {
  return projectOffset(vec3Sub(p, view.target), view)[2];
}
